import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {EnzymeType} from 'molbio/enzymes/backbone/Enzymes';
import {CutsiteFilter} from 'molbio/tabstates/MiniMapTabState';
import Button, {ButtonStyle} from 'ui-library/buttons/Button';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import {PopoverWarningBadge} from 'ui-library/WarningBadge';

const ENZYME_TYPE_TO_FILTER_DISPLAY: {[enzymeType in EnzymeType]: string} = {
  [EnzymeType.ALL]: 'all enzymes',
  [EnzymeType.NONE]: 'selected and compatible cutters',
  [EnzymeType.SINGLEANDDOUBLE]: 'single and double cutters',
  [EnzymeType.SINGLE]: 'single cutters',
  [EnzymeType.DOUBLE]: 'double cutters',
};

function PopoverContent({
  cutsiteFilter,
  onHiddenCutsitesLinkClick,
}: {
  cutsiteFilter: CutsiteFilter;
  onHiddenCutsitesLinkClick: () => void;
}): JSX.Element {
  // eslint-disable-next-line react/no-unstable-nested-components -- Disabling for now, but worth fixing
  const CutsitesTextLink = ({text}: {text: string}): JSX.Element => (
    <Button
      buttonStyle={ButtonStyle.LINK}
      className={css(styles.buttonLink)}
      text={text}
      onClick={onHiddenCutsitesLinkClick}
    />
  );
  const blackList = cutsiteFilter.blackList;
  const formattedBlackList =
    blackList.length > 0 ? ` (without ${blackList.map((enzyme) => enzyme.get('name')).join(', ')})` : '';
  const newFilter =
    cutsiteFilter.after != null ? (
      <span>
        Only <CutsitesTextLink text={ENZYME_TYPE_TO_FILTER_DISPLAY[cutsiteFilter.after]} />
        {formattedBlackList}
      </span>
    ) : (
      <CutsitesTextLink text="No enzymes" />
    );

  return <span>{newFilter} are being displayed to reduce clutter.</span>;
}

export default function HiddenCutsitesWarningBadge({
  cutsiteFilter,
  onHiddenCutsitesLinkClick,
  iconOnly = false,
}: {
  cutsiteFilter: CutsiteFilter;
  onHiddenCutsitesLinkClick: () => void;
  iconOnly?: boolean;
}): JSX.Element {
  return (
    <BufferOptionsItem>
      <PopoverWarningBadge
        content={iconOnly ? null : 'Cutsites Hidden'}
        className={css(styles.badge)}
        popoverProps={{
          renderContent: () => (
            <PopoverContent
              cutsiteFilter={cutsiteFilter}
              onHiddenCutsitesLinkClick={onHiddenCutsitesLinkClick}
            />
          ),
          title: 'Cutsites',
          placement: FloatingPlacement.BOTTOM,
        }}
      />
    </BufferOptionsItem>
  );
}

const styles = StyleSheet.create({
  buttonLink: {
    verticalAlign: 'baseline',
  },
  badge: {
    whiteSpace: 'nowrap',
  },
});
